import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Error from '../components/Error';


function Work() {
  return (
    <div>
      {/* <Header /> */}
      <Error />
      {/* <Footer /> */}
    </div>
  )
}

export default Work